

















import { Component, Vue, Prop } from 'vue-property-decorator';
import animateScrollTo from 'animated-scroll-to';
import { dragscroll } from 'vue-dragscroll';

interface TabItem {
  value: string;
  class: string;
  isActive: boolean;
}

@Component({
  directives: {
    dragscroll,
  },
})
export default class NavigationTab extends Vue {
  @Prop()
  items!: string[];

  @Prop()
  isLoading!: boolean;

  @Prop()
  initalTab!: number;

  tabItems: TabItem[] = [];

  activeClass =
    'border-b-1 border-solid border-red-100 py-10 px-6 text-red-100';

  unactiveClass =
    'border-b-1 border-solid border-white-100 py-10 px-6 text-gray-400 sm:hover:text-red-100';

  created() {
    let selectedTabIndex = 0;
    this.tabItems = this.items.map((item, index) => {
      return {
        value: item,
        class: this.unactiveClass + this.generateItemName(index),
        isActive: false,
      };
    });

    if (this.initalTab) {
      selectedTabIndex = this.initalTab;
    }

    this.tabItems[selectedTabIndex].isActive = true;
    this.tabItems[selectedTabIndex].class =
      this.activeClass + this.generateItemName(selectedTabIndex);
  }

  tabItemClick(selectedIndex: number, isActive: boolean) {
    if (isActive || this.isLoading) return;

    const prevItemIndecies = [...Array(selectedIndex).keys()];
    let distanceToMove = 0;

    prevItemIndecies.forEach(prevItemIndex => {
      const styleIndex = prevItemIndex + 1;
      const item: any = document.querySelector(
        `.slider-tab-item-${styleIndex}`,
      );

      if (item) {
        const itemStyle = getComputedStyle(item);
        distanceToMove += item.offsetWidth + parseInt(itemStyle.marginLeft);
      }
    });

    const navigationTab: any = document.getElementById('SLIDER-MAIN-TAB');
    this.tabItems = this.tabItems.map((item, itemIndex) => {
      if (itemIndex === selectedIndex) {
        item.class = this.activeClass + this.generateItemName(itemIndex);
        item.isActive = true;
      } else {
        item.class = this.unactiveClass + this.generateItemName(itemIndex);
        item.isActive = false;
      }

      return item;
    });

    animateScrollTo([distanceToMove, 0], { elementToScroll: navigationTab });
    this.$emit('updateActiveTab', selectedIndex);
  }

  generateItemName(itemIndex: number) {
    return ` slider-tab-item-${itemIndex + 1}`;
  }
}
